import React from "react";
import Banner from "../../components/templates/home/Contact/Banner";
import Cards from "../../components/templates/home/Contact/OptionsSection";

const Contact = () => {
  return (
    <div>
      <Banner />
      <Cards />
    </div>
  );
};

export default Contact;
